export const formatNumber = (number?: null | number) => {
  if (number === undefined || number === null) {
    return "Not found";
  }
  if (number === -1 || number == Infinity) {
    return undefined;
  }
  if (0 < number && number < 1) {
    return number.toFixed(2);
  }
  return number?.toLocaleString();
};

export const formatHoursAndMinutes = (hours: number) => {
  if (hours === undefined || hours === null) {
    return { hours: 0, minutes: 0 };
  }

  const totalMinutes = Math.round(hours * 60);
  const wholeHours = Math.floor(totalMinutes / 60);
  const remainingMinutes = totalMinutes % 60;

  return {
    hours: wholeHours,
    minutes: remainingMinutes,
  };
};
